export const constants = {
  LOCALSTORAGE_TOKENS_ID: "TOKENS",
};
